import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import Accordion, { Item as AccordionItem } from "devextreme-react/accordion";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarCpbsDs,
  criarMunicipioDs,
  criarContadorDs,
  criarCategoriaCpbsDs,
  criarRegimeTributarioDs,
  criarSituacaoCadastralDs,
  criarTipoRecolhimentoDs,
  criarNaturezaJuridicaReceitaDs,
  criarContribuinteDs,
  criarGrauInstrucaoCpbsDs,
  criarTaxasDs,
  criarImovelDs,
  criarPaisBacenDs,
  criarPrefeituraDs,
} from "../../DataSources";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import ImovelBox from "../imovel/ImovelBox";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import { TextBox, Button as TextBoxButton } from "devextreme-react/text-box";
import { Button, ScrollView, Template } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import Toolbar, { Item } from "devextreme-react/toolbar";
import uiInfo from "../../ui-info";
import ShowError from "../../AppServices";
import apiAxios from "../../api-axios";
import { LoadIndicator } from "devextreme-react/load-indicator";
import Memoria from "../../Memoria";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

let dataAtual = new Date();

const template = {
  id: undefined,
  inscricao: undefined,
  dataDeCadastro: dataAtual,
  dataDeAbertura: dataAtual,
  dataDeInicioDeAtividade: dataAtual,
  cep: "",
  endereco: "",
  numero: "",
  complemento: "",
  bairro: "",
  municipioId: UserInfo.getMunicipioId(),
  paisBacenId: 1058,
  telefone: "",
  celular: "",
  categoriaId: undefined,
  situacaoCadastralId: undefined,
  naturezaJuridicaId: undefined,
  NaturezaJuridicaReceitaId: undefined,
  prefeituraId: UserInfo.getPrefeitura(),
  email: "",
  numeroPrimeiraNf: undefined,
  tipoContribuinteIss: 3,
  optanteSimples: false,
  tipoIss: 0,
  tipoEscrituracao: 0,
  dispensaIss: 0,
  qtdeProfissionais: undefined,
  valorIssEstimativa: undefined,
  dataLimiteNfse: undefined,
  ultimaNfseAutorizada: undefined,
  horarioDeFuncionamento: "",
  horarioDeFuncionamento2: "",
  horarioDeFuncionamento3: "",
  popupImovelVisivel: false,
  loadIndicatorVisivel: false,
  textoBotao: "Salvar",
  posicaoFiscalTllf: 0,
  posicaoFiscalTlas: 0,
  possuiTllf: 1,
  possuiTlas: 2,
  unidadesTllf: 0,
  unidadesTlas: 0,
  validadeCartaoIss: new Date(dataAtual.getFullYear(), 11, 31),
  autorizacaoNfe: 0,
};

export default class CpbsForm extends React.Component {
  constructor(props) {
    super(props);
    this.cpbsDs = criarCpbsDs();
    this.contribuinteDs = criarContribuinteDs();
    this.grauInstrucaoDs = criarGrauInstrucaoCpbsDs();
    this.paisDs = criarPaisBacenDs();
    this.municipioDs = criarMunicipioDs();
    this.prefeituraDs = criarPrefeituraDs();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.state = { ...(_cadastroCorrente || template), _uiCarregando: true };
    this.renderLabel = this.renderLabel.bind(this);
    this.renderCpfCnpj = this.renderCpfCnpj.bind(this);
    this.renderContribuinte = this.renderContribuinte.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.imovelBoxRef = React.createRef();
    //Funções do imóvel
    /*
    /*
    */
    this.imovelDs = criarImovelDs();
    this.setImovelId = this.setImovelId.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.onImovelSelecionadoPesquisa =
      this.onImovelSelecionadoPesquisa.bind(this);
    this.renderImovel = sysCodigoDescricao(
      () => this.state.imovelId,
      this.setImovelId,
      () => this.state._uiNomeImovel,
      this.pesquisarImovel
    );
    this.atualizarNomeImovel = this.atualizarNomeImovel.bind(this);
    /*
  /*
  */
    //Fim da funções do imóvel

    this.onContribuinteSelecionadoPesq =
      this.onContribuinteSelecionadoPesq.bind(this);
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.atualizarInfoCpbs = this.atualizarInfoCpbs.bind(this);
    this.setContribuinte = this.setContribuinte.bind(this);
    this.renderLabelToolbar = this.renderLabelToolbar.bind(this);

    this.grauInstrucaoOptions = {
      editorType: "dxSelectBox",
      dataSource: this.grauInstrucaoDs,
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
      placeholder: " ",
    };

    this.opcoesTLLF = {
      editorType: "dxSelectBox",
      dataSource: criarTaxasDs("TLLF"),
      valueExpr: "sequencial",
      displayExpr: "descricao",
      showClearButton: true,
    };

    this.opcoesTLAS = {
      editorType: "dxSelectBox",
      dataSource: criarTaxasDs("TLAS"),
      valueExpr: "sequencial",
      displayExpr: "descricao",
      showClearButton: true,
      onValueChanged: async (e) => {
        let taxas = await criarTaxasDs("TLAS").load({
          filter: ["sequencial", "=", e.value],
        });
        console.log(taxas);
      },
    };

    this.contadorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarContadorDs(),
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.categoriaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarCategoriaCpbsDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.regimeTributarioOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarRegimeTributarioDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.situacaoCadastralOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarSituacaoCadastralDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.naturezaJuridicaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarNaturezaJuridicaReceitaDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoRecolhimentoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarTipoRecolhimentoDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoContribuinteOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: 0, descricao: "PRESTADOR" },
        { id: 1, descricao: "SUBSTITUTO" },
        { id: 2, descricao: "MIST" },
        { id: 3, descricao: "NÃO CONTRIBUINTE" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.simplesNacionalOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoIss = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: 0, descricao: "NÃO CONTRIBUINTE" },
        { id: 1, descricao: "NORMAL" },
        { id: 2, descricao: "AUTÔNOMO" },
        { id: 3, descricao: "SOCIEDADE DE PROFISSIONAIS" },
        { id: 4, descricao: "ESTIMATIVA" },
        { id: 7, descricao: "MEI" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.setState({ tipoIss: e.value }),
    };

    this.tipoEscrituracao = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: [
        { id: 0, descricao: "SEM ESCRITURAÇÃO" },
        { id: 1, descricao: "NOTAS FISCAIS" },
        { id: 2, descricao: "INSTITUIÇÕES FINANCEIRAS" },
        { id: 3, descricao: "CARTÓRIOS" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.paisOptions = {
      editorType: "dxLookup",
      searchEnabled: true,
      dataSource: this.paisDs,
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.possuiAlvaraOptions = {
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.posicaoFiscalAlvaraOptions = {
      dataSource: [
        { id: 0, descricao: "TRIBUTÁVEL" },
        { id: 1, descricao: "IMUNE" },
        { id: 2, descricao: "ISENTO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.autorizacaoNfeOptions = {
      dataSource: [
        { id: 0, descricao: "NÃO AUTORIZADO" },
        { id: 1, descricao: "NFS-e" },
        { id: 2, descricao: "DMS" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.dispensaIssOptions = {
      dataSource: [
        { id: 0, descricao: "NÃO" },
        { id: 1, descricao: "ISENTO" },
        { id: 2, descricao: "IMUNE" },
        { id: 3, descricao: "PERMITE ISENTO" },
        { id: 4, descricao: "PERMITE IMUNE" },
        { id: 5, descricao: "PERMITE ISENTO E IMUNE" },
        { id: 6, descricao: "NÃO TRIBUTÁVEL" },
        { id: 7, descricao: "PERMITE NÃO TRIBUTÁVEL" },
        { id: 99, descricao: "PERMITE TUDO" }
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  //Funções do imóvel
  /*
  /*
  */

  async setImovelId(data) {
    this.setState({ imovelId: data.value });
    this.atualizarNomeImovel();
  }

  atualizarNomeImovel() {
    this.imovelDs
      .load({ filter: [["sequencial", "=", this.state.imovelId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setState({
            _uiNomeImovel: result[0].enderecoCompleto,
            cep: result[0].cep,
            endereco: result[0].logradouro.nomeCompleto,
            numero: result[0].numero,
            complemento: result[0].complemento,
            bairro: result[0].bairro.descricao,
          });
        } else {
          this.setState({ _uiNomeImovel: "" });
        }
        console.log(this.state);
      })
      .catch((_) => this.setState({ _uiNomeImovel: "<<ERRO>>" }));
  }

  onImovelSelecionadoPesquisa(e) {
    this.setState({
      imovelId: e.row.data.sequencial,
      popupImovelVisivel: false,
    });
    this.atualizarNomeImovel();
  }

  pesquisarImovel() {
    this.setState({ popupImovelVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do imóvel

  onContribuinteSelecionadoPesq(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      exibirPesqContribuinte: false,
    });
    this.atualizarInfoCpbs();
  }

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarInfoCpbs();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ exibirPesqContribuinte: true });
  }

  atualizarInfoCpbs() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        if (result.length !== 0) {
          this.setContribuinte(result[0]);
        } else {
          this.setContribuinte(undefined);
        }
      })
      .catch((_) => this.setContribuinte(undefined));
  }

  setContribuinte(entidade) {
    if (entidade === undefined) {
      this.setState({
        _uiCpfCnpj: "",
        _uiNome: "",
        _uiApelido: "",
        _uiEndereco: "",
      });
    } else {
      this.setState({
        _uiCpfCnpj: entidade.cpfCnpjFormatado,
        _uiNome: entidade.nome,
        _uiApelido: entidade.apelido,
        _uiEndereco: entidade.enderecoCompleto,
      });
    }
  }

  renderContribuinte() {
    return (
      <TextBox
        value={this.state.contribuinteId}
        onValueChanged={this.setContribuinteId}
      >
        <TextBoxButton
          name="btnPesquisa"
          location="after"
          options={{ icon: "search", onClick: this.pesquisarContribuinte }}
        />
      </TextBox>
    );
  }

  renderLabel(data) {
    return <div>{this.state[data.dataField]}</div>;
  }

  renderCpfCnpj(data) {
    return (
      <div style={{ fontWeight: "bold" }}>
        <div style={{ display: "inline-block", marginRight: "5px" }}>
          CPF/CNPJ:
        </div>
        <div style={{ display: "inline-block" }}>
          {this.state[data.dataField]}
        </div>
      </div>
    );
  }

  setCpbsCpbs(cpbs) {}

  async componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      const todosMunicipios = await this.municipioDs.load();
      const prefeitura = await this.prefeituraDs.byKey(
        UserInfo.getPrefeitura()
      );

      const municipioId =
        prefeitura == undefined ? undefined : prefeitura.municipioId;

      this.setState({
        ...template,
        municipioId: municipioId,
        _uiListaMunicipios: todosMunicipios,
      });

      if (this.props.match.params.id !== undefined) {
        this.cpbsDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/cpbs");
            }

            const imovelId =
              data.imovel == undefined ? undefined : data.imovel.sequencial;
            const servicoId =
              data.servicoAutonomo == undefined
                ? undefined
                : data.servicoAutonomo.sequencial;

            let novoEstado = {
              id: data.id,
              inscricao: data.inscricao,
              contribuinteId: data.contribuinte.sequencial,
              dataDeCadastro: data.dataDeCadastro,
              dataDeAbertura: data.dataDeAbertura,
              dataDeInicioDeAtividade: data.dataDeInicioDeAtividade,
              fantasia: data.fantasia,
              categoriaId: data.categoriaId,
              situacaoCadastralId: data.situacaoCadastralId,
              prefeituraId: data.prefeituraId,
              email: data.contribuinte.email,
              numeroPrimeiraNf: data.numeroPrimeiraNf,
              tipoContribuinteIss: data.tipoContribuinteIss,
              optanteSimples: data.optanteSimples,
              tipoIss: data.tipoIss,
              tipoEscrituracao: data.tipoEscrituracao,
              dispensaIss: data.dispensaIss,
              qtdeProfissionais: data.qtdeProfissionais,
              valorIssEstimativa: data.valorIssEstimativa,
              dataLimiteNfse: data.dataLimiteNfse,
              ultimaNfseAutorizada: data.ultimaNfseAutorizada,
              area: data.area,
              cartografia: data.cartografia,
              horarioDeFuncionamento: data.horarioDeFuncionamento,
              horarioDeFuncionamento2: data.horarioDeFuncionamento2,
              horarioDeFuncionamento3: data.horarioDeFuncionamento3,
              imovelId: data.imovel?.sequencial,
              grauDeInstrucaoId: data.grauDeInstrucaoId,
              cpfCnpj: data.contribuinte?.documentoFormatado,
              endereco: data.endereco,
              taxaTllfId: data.taxaTllfId,
              isentoTLLF: data.isentoTLLF,
              taxaTlasId: data.taxaTlasId,
              isentoTLAS: data.isentoTLAS,
              naturezaJuridicaReceitaId: data.naturezaJuridicaReceitaId,

              naturezaJuridicaId: data.naturezaJuridicaId,
              regimeTributarioId: data.regimeTributarioId,
              regimeTributarioId: data.regimeTributarioId,
              tipoDeRecolhimentoId: data.tipoDeRecolhimentoId,
              grauDeInstrucaoId: data.grauDeInstrucaoId,
              categoriaId: data.categoriaId,

              cep: data.cep,
              endereco: data.endereco,
              numero: data.numero,
              complemento: data.complemento,
              bairro: data.bairro,
              cidade: data.cidade,
              uf: data.uf,
              pais: data.pais,
              municipioId: data.municipioId,
              paisBacenId: data.paisBacenId,

              telefone: data.telefone,
              celular: data.celular,
              email: data.email,
              descricaoAtividade: data.descricaoAtividade,

              validadeCartaoIss: data.validadeCartaoIss,
              ultimaNfseAutorizada: data.ultimaNfseAutorizada,
              qtdeProfissionaisSociedade: data.qtdeProfissionaisSociedade,
              qtdeProfissionaisEstabelecimento:
                data.qtdeProfissionaisEstabelecimento,
              valorPorProfissional: data.valorPorProfissional,
              baseCalculoIssEstimativa: data.baseCalculoIssEstimativa,

              imovelId: imovelId,
              servicoAutonomoId: servicoId,

              posicaoFiscalTllf: data.posicaoFiscalTllf,
              posicaoFiscalTlas: data.posicaoFiscalTlas,
              possuiTllf: data.possuiTllf,
              possuiTlas: data.possuiTlas,
              unidadesTllf: data.unidadesTllf,
              unidadesTlas: data.unidadesTlas,

              _uiNome: data.contribuinte.nome,
              _uiCpfCnpj: data.contribuinte.cpfCnpjFormatado,
              _uiCarregando: false,

              autorizacaoNfe: data.autorizacaoNfe,
            };

            this.setState(novoEstado);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template, _uiCarregando: false });
      }
    } else {
      this.setState({ ..._cadastroCorrente, _uiCarregando: false });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  showMotivoBloqueio() {
    if (this.state.usarioBloqueado == true) {
      return (
        <SimpleItem
          colSpan={2}
          dataField={"infoBloqueio"}
          editorType={"dxTextArea"}
        >
          <Label>Motivo da Desativação</Label>
        </SimpleItem>
      );
    }
  }

  showMotivoDesativacao() {
    if (this.state.usuarioAtivo == false) {
      return (
        <SimpleItem
          colSpan={2}
          dataField={"infoDesativacao"}
          editorType={"dxTextArea"}
        >
          <Label>Motivo da Desativação</Label>
        </SimpleItem>
      );
    }
  }

  renderLabelToolbar() {
    return (
      <div className="toolbar-label">
        <b>
          <h3>CADASTRO ECONÔMICO</h3>
        </b>
      </div>
    );
  }

  render() {
    if (this.state._uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <LoadIndicator width={60} height={60} />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Toolbar>
            <Item
              location="left"
              locateInMenu="never"
              render={this.renderLabelToolbar}
            />
            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Cadastro de Sócios",
                type: "success",
                onClick: () => {
                  localStorage.setItem("inscricao_cpbs", this.state.inscricao);
                  localStorage.setItem("id_cpbs", this.props.match.params.id);
                  this.props.history.push(
                    "/cpbs_socios/" + this.props.match.params.id
                  );
                },
              }}
              visible={this.props.match.params.id !== undefined}
            />
            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Cadastro de Cnaes",
                type: "success",
                onClick: () => {
                  localStorage.setItem("inscricao_cpbs", this.state.inscricao);
                  localStorage.setItem("id_cpbs", this.props.match.params.id);
                  this.props.history.push(
                    "/cpbs_cnaes/" + this.props.match.params.id
                  );
                },
              }}
              visible={this.props.match.params.id !== undefined}
            />
            <Item
              location="after"
              locateInMenu="auto"
              widget="dxButton"
              options={{
                text: "Gestão de Usuário NFS-e",
                type: "success",
                onClick: () => {
                  localStorage.setItem("inscricao_cpbs", this.state.inscricao);
                  localStorage.setItem("id_cpbs", this.props.match.params.id);
                  this.props.history.push(
                    "/usuario_nfse/" + this.props.match.params.id
                  );
                },
              }}
              visible={this.props.match.params.id !== undefined}
            />
          </Toolbar>
          <br />
          <br />
          <Form formData={this.state} colCount={4} labelLocation={"top"}>
            <GroupItem colSpan={4} colCount={4}>
              <SimpleItem
                dataField={"inscricao"}
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.inteiroSemPonto,
                  disabled: this.props.match.params.id ? true : false,
                }}
              >
                <Label text="Nº de Inscrição" />
              </SimpleItem>

              <SimpleItem
                dataField={"naturezaJuridicaReceitaId"}
                editorType={"dxSelectBox"}
                editorOptions={this.naturezaJuridicaOptions}
                colSpan={2}
              >
                <Label text="Natureza Jurídica" />
              </SimpleItem>

              <SimpleItem
                dataField={"situacaoCadastralId"}
                editorType={"dxSelectBox"}
                editorOptions={this.situacaoCadastralOptions}
                colSpan={2}
              >
                <Label text="Situação Cadastral" />
              </SimpleItem>

              <SimpleItem
                dataField={"contribuinteId"}
                colSpan={1}
                render={this.renderContribuinte}
              >
                <Label text="Contribuinte" />
              </SimpleItem>

              <SimpleItem
                dataField={"dataDeCadastro"}
                editorType={"dxDateBox"}
                editorOptions={{
                  type: "date",
                  width: "100%",
                  useMaskBehavior: true,
                }}
              >
                <Label text="Dt. Inscrição" />
              </SimpleItem>
              <SimpleItem
                dataField={"dataDeAbertura"}
                editorType={"dxDateBox"}
                editorOptions={{
                  type: "date",
                  width: "100%",
                  useMaskBehavior: true,
                }}
              >
                <Label text="Dt. Abertura" />
              </SimpleItem>

              <SimpleItem
                dataField={"dataDeInicioDeAtividade"}
                editorType={"dxDateBox"}
                editorOptions={{
                  type: "date",
                  width: "100%",
                  useMaskBehavior: true,
                }}
              >
                <Label text="Dt. Início" />
              </SimpleItem>

              <SimpleItem
                dataField={"_uiCpfCnpj"}
                editorOptions={{ readOnly: true }}
              >
                <Label text="CPF/CNPJ" />
              </SimpleItem>

              <SimpleItem
                dataField={"_uiNome"}
                colSpan={2}
                editorOptions={{ readOnly: true }}
              >
                <Label text="Nome/Razão Social" />
              </SimpleItem>

              <SimpleItem dataField={"fantasia"} colSpan={2}>
                <Label text="Fantasia" />
              </SimpleItem>
            </GroupItem>

            <GroupItem
              colSpan={4}
              colCount={4}
              caption="INFORMAÇÕES PARA CONTATO"
            >
              <SimpleItem dataField={"telefone"}>
                <Label text="Telefone" />
              </SimpleItem>
              <SimpleItem dataField={"celular"}>
                <Label text="Celular" />
              </SimpleItem>
              <SimpleItem dataField={"email"} colSpan={2}>
                <Label text="E-mail" />
              </SimpleItem>
            </GroupItem>

            <GroupItem colSpan={4} colCount={8} caption="ENDEREÇO">
              <SimpleItem render={this.renderImovel} colSpan={8}>
                <Label text="Inscrição do Imóvel" />
              </SimpleItem>
              <SimpleItem
                dataField={"cep"}
                editorType={"dxTextBox"}
                editorOptions={{ mask: "00.000-000" }}
              >
                <Label text="CEP" />
              </SimpleItem>

              <SimpleItem dataField={"endereco"} colSpan={6}>
                <Label text="Logradouro" />
              </SimpleItem>

              <SimpleItem dataField={"numero"}>
                <Label text="Número" />
              </SimpleItem>

              <SimpleItem dataField={"complemento"} colSpan={2}>
                <Label text="Complemento" />
              </SimpleItem>

              <SimpleItem dataField={"bairro"} colSpan={2}>
                <Label text="Bairro" />
              </SimpleItem>

              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                colSpan={2}
                editorOptions={{
                  dataSource: this.state._uiListaMunicipios,
                  valueExpr: "id",
                  displayExpr: "nomeCompleto",
                }}
              >
                <Label text="Cidade" />
              </SimpleItem>

              <SimpleItem
                dataField={"paisBacenId"}
                editorType={"dxLookup"}
                editorOptions={this.paisOptions}
                colSpan={2}
              >
                <Label text="País" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <Accordion
            collapsible={true}
            multiple={true}
            animationDuration={300}
            onSelectionChanged={this.selectionChanged}
          >
            <AccordionItem title="Funcionamento">
              <Form formData={this.state} labelLocation="top" colCount={6}>
                <SimpleItem
                  dataField={"area"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Área do Estabelecimento" />
                </SimpleItem>

                <SimpleItem
                  dataField={"categoriaId"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.categoriaOptions}
                  colSpan={5}
                >
                  <Label text="Categoria do Econômico" />
                </SimpleItem>

                <SimpleItem
                  dataField={"taxaTllfId"}
                  colSpan={3}
                  editorType={"dxSelectBox"}
                  editorOptions={this.opcoesTLLF}
                >
                  <Label text="TLLF" />
                </SimpleItem>

                {/* <SimpleItem
                dataField={"isentoTLLF"}
                colSpan={2}
                editorType={"dxCheckBox"}
                editorOptions={{ defaultValue: false, text: "Isento TLLF" }}
              >
                <Label visible={false} />
              </SimpleItem> */}

                <SimpleItem
                  dataField={"possuiTllf"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.possuiAlvaraOptions}
                >
                  <Label text={"Sujeito TLLF"} />
                </SimpleItem>

                <SimpleItem
                  dataField={"posicaoFiscalTllf"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.posicaoFiscalAlvaraOptions}
                >
                  <Label text={"Pos. Fiscal TLLF"} />
                </SimpleItem>

                <SimpleItem
                  dataField={"unidadesTllf"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Qtde. Un. Med. TLLF" />
                </SimpleItem>

                <SimpleItem
                  dataField={"taxaTlasId"}
                  colSpan={3}
                  editorType={"dxSelectBox"}
                  editorOptions={this.opcoesTLAS}
                >
                  <Label text="TLAS" />
                </SimpleItem>

                {/* <SimpleItem
                dataField={"isentoTLAS"}
                colSpan={2}
                editorType={"dxCheckBox"}
                editorOptions={{ defaultValue: false, text: "Isento TLAS" }}
              >
                <Label visible={false} />
              </SimpleItem> */}

                <SimpleItem
                  dataField={"possuiTlas"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.possuiAlvaraOptions}
                >
                  <Label text={"Sujeito TLAS"} />
                </SimpleItem>

                <SimpleItem
                  dataField={"posicaoFiscalTlas"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.posicaoFiscalAlvaraOptions}
                >
                  <Label text={"Pos. Fiscal TLAS"} />
                </SimpleItem>

                <SimpleItem
                  dataField={"unidadesTlas"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Qtde. Un. Med. TLAS" />
                </SimpleItem>

                <SimpleItem dataField={"horarioDeFuncionamento"} colSpan={2}>
                  <Label text="Horário 1" />
                </SimpleItem>
                <SimpleItem dataField={"horarioDeFuncionamento2"} colSpan={2}>
                  <Label text="Horário 2" />
                </SimpleItem>
                <SimpleItem dataField={"horarioDeFuncionamento3"} colSpan={2}>
                  <Label text="Horário 3" />
                </SimpleItem>
              </Form>
            </AccordionItem>
            <AccordionItem title="Classificação ISS">
              <Form formData={this.state} labelLocation="top" colCount={4}>
                <SimpleItem
                  dataField={"tipoContribuinteIss"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoContribuinteOptions}
                >
                  <Label text="Tipo Contribuinte" />
                </SimpleItem>

                <SimpleItem
                  dataField={"optanteSimples"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.simplesNacionalOptions}
                >
                  <Label text="Simples Nacional" />
                </SimpleItem>

                <SimpleItem
                  dataField={"tipoIss"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoIss}
                >
                  <Label text="Tipo de Recolhimento" />
                </SimpleItem>

                <SimpleItem
                  dataField={"tipoEscrituracao"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoEscrituracao}
                >
                  <Label text="Tipo Escrituração" />
                </SimpleItem>
                <SimpleItem
                  cssClass={"txtFrmCpbsNumerico"}
                  editorType={"dxNumberBox"}
                  dataField={"numeroPrimeiraNf"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroComPonto,
                  }}
                >
                  <Label text="N.º Primeira Nota Fiscal" />
                </SimpleItem>

                <SimpleItem
                  dataField={"validadeCartaoIss"}
                  editorType={"dxDateBox"}
                  dataType={"date"}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Validade Cartão ISS" />
                </SimpleItem>
                <SimpleItem
                  dataField={"grauDeInstrucaoId"}
                  editorType={"dxSelectBox"}
                  visible={this.state.tipoIss === 2}
                  editorOptions={this.grauInstrucaoOptions}
                >
                  <Label text="Grau de Instrução" />
                </SimpleItem>

                <SimpleItem
                  dataField={"servicoAutonomoId"}
                  visible={this.state.tipoIss === 2}
                >
                  <Label text="Serviço Autônomo" />
                </SimpleItem>
                <SimpleItem
                  dataField={"autorizacaoNfe"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.autorizacaoNfeOptions}
                >
                  <Label text="Autorização NFE e DMS" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dispensaIss"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.dispensaIssOptions}
                >
                  <Label text="Dispensa ISS" />
                </SimpleItem>
              </Form>
            </AccordionItem>
            <AccordionItem title="Outras Informações">
              <Form formData={this.state} labelLocation="top" colCount={4}>
                <SimpleItem
                  dataField={"dataLimiteNfse"}
                  editorType={"dxDateBox"}
                  editorOptions={{ editorType: "date", width: "100%" }}
                >
                  <Label text="Data Limite NFS-e" />
                </SimpleItem>

                <SimpleItem
                  dataField={"ultimaNfseAutorizada"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroComPonto,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Últ. NFS-e Autorizada" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"qtdeProfissionaisSociedade"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroSemPonto,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Qtde. Profissionais Sociedade" />
                </SimpleItem>

                <SimpleItem
                  dataField={"qtdeProfissionaisEstabelecimento"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.inteiroSemPonto,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Qtde. Profissionais Estabelecimento" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"valorPorProfissional"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor Por Profissional (R$)" />
                </SimpleItem>

                <SimpleItem
                  dataField={"baseCalculoIssEstimativa"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Base Cálculo ISS Estimativa" />
                </SimpleItem>

                <SimpleItem
                  dataField={"valorIssEstimativa"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor ISS Estimativa (R$)" />
                </SimpleItem>
              </Form>
            </AccordionItem>
          </Accordion>
          <br />
          <br />
          <Form formData={this.state} colCount={4} labelLocation={"top"}>
            <GroupItem
              colSpan={4}
              colCount={1}
              caption="Descrição da Atividade"
            >
              <SimpleItem
                dataField="descricaoAtividade"
                editorType={"dxTextArea"}
                editorOptions={{ height: 150 }}
                colSpan={2}
              >
                <Label visible={false} />
              </SimpleItem>
            </GroupItem>
          </Form>

          <br />
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
                disabled={this.state.loadIndicatorVisivel}
              >
                <LoadIndicator
                  className="button-indicator"
                  id="small-indicator"
                  height={20}
                  width={20}
                  visible={this.state.loadIndicatorVisivel}
                  style={{ marginRight: "10px", verticalAlign: "middle" }}
                />
                <span className="dx-button-text">{this.state.textoBotao}</span>
              </Button>
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                disabled={this.state.loadIndicatorVisivel}
                text="Cancelar"
                width={120}
                onClick={this.cancel}
              />
            </div>
          </div>

          <Popup
            visible={this.state.exibirPesqContribuinte}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesq}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ exibirPesqContribuinte: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupImovelVisivel}
            onHiding={() => this.setState({ popupImovelVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Imóvel"
          >
            <ScrollView showScrollbar={"always"}>
              <ImovelBox
                onSelecionado={this.onImovelSelecionadoPesquisa}
                ref={this.imovelBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupImovelVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    this.setState(
      {
        loadIndicatorVisivel: true,
        textoBotao: "Salvando...",
      },
      async () => {
        try {
          const entidade = { ...this.state, _uiListaMunicipios: undefined };
          console.log("dados enviados", entidade);
          const url = "/cpbs";
          const novoCadastro = entidade.id == undefined || entidade.id == 0;
          const response = novoCadastro
            ? await apiAxios.post(url, entidade)
            : await apiAxios.put(url, entidade);

          if (response.status === 200) {
            _cadastroCorrente = undefined;
            _cancelando = true;
            Memoria.removerEdicao(this.props.location);
            notify("Cpbs cadastrado com sucesso.", "success");
            if (novoCadastro === true) {
              this.props.history.push(`/cpbs/editar/${response.data.id}`);
            } else {
              this.props.history.push(`/cpbs`);
            }
          }
        } catch (error) {
          console.log(error);
          if (error.response && error.response.data) {
            ShowError(error.response.data);
          } else {
            ShowError(error);
          }
        }
        this.setState({ loadIndicatorVisivel: false, textoBotao: "Salvar" });
      }
    );
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.push("/cpbs");
  }
}
